export default [
  {
    path: "/modules-calendar",
    name: "module-calendar",
    component: () =>
      import("@/views/custom-modules/calendar/CalendarModule.vue"),
    meta: { rule: "editor", no_scroll: true },
    customModuleRoute: true
  },
  {
    path: "/modules/external-link/:url",
    name: "modules-external-link",
    component: () => import("@/views/custom-modules/ExternalLinkModule.vue"),
    meta: { rule: "editor" },
    customModuleRoute: true
  },
  {
    path: "/modules/view/:moduleHash",
    name: "modules-view-single-row",
    component: () => import("@/views/custom-modules/view/View.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Módulos", url: "/module-management" },
        { title: "Visualizar", active: true }
      ],
      rule: "editor",
      customModuleRoute: true
    }
  },
  {
    path: "/modules/view/:moduleHash/:rowHash",
    name: "modules-view",
    component: () => import("@/views/custom-modules/view/View.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Módulos", url: "/module-management" },
        { title: "Visualizar", active: true }
      ],
      rule: "editor",
      customModuleRoute: true
    }
  },
  {
    path: "/modules/edit/:moduleHash",
    name: "modules-row-edit",
    component: () => import("@/views/custom-modules/edit/Edit.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Módulos", url: "/module-management" },
        { title: "Editar", active: true }
      ],
      rule: "editor",
      customModuleRoute: true
    }
  },
  {
    path: "/modules/edit/:moduleHash/:rowHash",
    name: "modules-row-edit-row",
    component: () => import("@/views/custom-modules/edit/Edit.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Módulos", url: "/module-management" },
        { title: "Editar", active: true }
      ],
      rule: "editor",
      customModuleRoute: true
    }
  },
  {
    path: "modules/kanban/:moduleHash",
    name: "kanban",
    component: () => import("@/views/Kanban.vue"),
    meta: {
      pageTitle: "Kanban",
      rule: "editor",
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Kanban", active: true }
      ],
      customModuleRoute: true
    }
  },
  {
    path:
      "/modules/add/:moduleHash/:relatedModuleHash?/:relatedModuleRowHash?/:relatedModuleFieldHash?",
    name: "modules-add-row",
    component: () => import("@/views/custom-modules/add/Add.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Módulos", url: "/module-management" },
        { title: "Cadastrar", active: true }
      ],
      rule: "editor",
      customModuleRoute: true
    }
  },
  {
    path: "/modules-search/:moduleHash",
    name: "modules-search",
    component: () =>
      import("@/views/custom-modules/list/ModuleAdvancedList.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Módulos", url: "/module-management" },
        { title: "Busca", active: true }
      ],
      pageTitle: "Módulos",
      rule: "editor",
      customModuleRoute: true
    }
  },
  {
    path: "/modules/:moduleHash/:listHash?",
    name: "modules",
    component: () => import("@/views/custom-modules/list/ModuleList.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Módulos", url: "/module-management" },
        { title: "Lista", active: true }
      ],
      pageTitle: "Módulos",
      rule: "editor",
      customModuleRoute: true
    }
  }
];

